module.exports = __webpack_public_path__ + "static/media/light6.2e561074.png";